import { Link } from "gatsby"
import React, { useState } from "react"

function TopMainNav() {
  const [isExpanded, toggleExpansion] = useState(false)

  const links = [
    {
      name: "Home",
      link: "/",
    },
    /*{
      name: "Teachers",
      link: "/treat-your-teacher/",
    },*/
    {
      name: "Christmas",
      link: "/give-the-gift-of-merry-moments-together/",
    },
    {
      name: "Gift Cards",
      link: "/gift-cards/",
    },
    {
      name: "Our Venues",
      link: "/ourvenues/",
    },
    {
      name: "Book a Table",
      link: "/book-a-table/",
    },
    {
      name: "Corporate Gifts",
      link: "/corporate-gifts/",
    },
  ]

  return (
    <div className="bg-blue">
      <nav className="flex flex-wrap items-center justify-center p-3 mx-auto max-w-[1110px]">
        <div className="block lg:hidden">
          <button
            onClick={() => toggleExpansion(!isExpanded)}
            className="flex items-center px-3 py-2 text-white border border-white rounded hover:text-white hover:border-white"
          >
            <svg
              className="w-3 h-3 fill-current"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Menu</title>
              <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
            </svg>
          </button>
        </div>
        <div
          className={`${
            isExpanded ? `block` : `hidden`
          } w-full block flex-grow lg:flex justify-center items-center lg:w-auto lg:justify-between`}
        >
          {links.map(link => (
            <Link
              to={link.link}
              key={link.name}
              className="block text-center text-white py-2 text-lg uppercase md:px-3 font-thin hover:text-gold focus:text-gold"
              activeClassName="!text-gold !font-semibold"
            >
              {link.name}
            </Link>
          ))}
        </div>
      </nav>
    </div>
  )
}

export default TopMainNav
